<template>
  <el-dialog
    :visible="visible"
    :title="dialogTitle"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
    @close="handleClose"
    width="1200px"
    class="warehouse-receipt-dialog"
  >
    <div class="receipt-content">
      <!-- 仓单基本信息 -->
      <div class="info-section">
        <div class="info-row">
          <div class="info-item">
            <label class="info-label">仓单总量（吨）</label>
            <el-input v-model="warehouseBaseData.totalQuantity" disabled class="info-input" />
          </div>
          <div class="info-item">
            <label class="info-label">仓单余额（吨）</label>
            <el-input v-model="warehouseBaseData.balanceQuantity" disabled class="info-input" />
          </div>
          <div class="info-item">
            <label class="info-label">质押数量（KG）</label>
            <el-input v-model="warehouseBaseData.pledgedQuantity" disabled class="info-input" />
          </div>
          <div class="info-item">
            <label class="info-label">质押贷款（元）</label>
            <el-input v-model="warehouseBaseData.pledgedLoanAmount" disabled class="info-input" />
          </div>
        </div>

        <div class="info-row">
          <div class="info-item">
            <label class="info-label">已出仓数量（吨）</label>
            <el-input v-model="warehouseBaseData.outQuantity" disabled class="info-input" />
          </div>
          <div class="info-item">
            <label class="info-label">仓储公司</label>
            <el-input
              v-model="warehouseBaseData.warehouseCompany"
              disabled
              class="info-input"
              style="width: 240px"
            />
          </div>
          <div class="info-item">
            <label class="info-label">贷款银行</label>
            <el-input v-model="warehouseBaseData.loanBank" disabled class="info-input" />
          </div>
        </div>
      </div>

      <!-- 出仓记录表 -->
      <div class="table-section">
        <h3 class="section-title">出入库记录</h3>
        <el-table :data="warehouseTableData" style="width: 100%" class="out-records-table">
          <el-table-column
            prop="documentNo"
            label="单据号"
            width="150"
            align="center"
            fixed="left"
          ></el-table-column>
          <el-table-column
            prop="registrar"
            label="登记员"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="quantityInOut"
            label="出入仓数量(吨)"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="grainType"
            label="粮食品种"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="grainGrade"
            label="粮食等级"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="warehouseName"
            label="出入仓库"
            width="180"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="registerTime"
            label="登记时间"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="outProgress"
            label="出库进度"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column prop="dataStatus" label="数据状态" align="center"></el-table-column>
        </el-table>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getReceiptDetailById } from '@/api/warehousingService'

export default {
  name: 'WarehouseReceiptDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    receiptNo: {
      type: String,
      default: ''
    },
    receiptId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogTitle: '',

      warehouseBaseData: {
        // totalQuantity: '20,000',
        // outQuantity: '7999.75',
        // warehouseCompany: '黑龙江绿野农业科技有限公司',
        // grainType: '小麦',
        // balanceQuantity: '12000.25',
        // pledgedQuantity: '1000000',
        // pledgedLoanAmount: '100000000',
        // loanBank: '中国建设银行'
      },

      warehouseTableData: [
        // {
        //   documentNo: '20230824001',
        //   registrar: '张三',
        //   quantityInOut: '1000',
        //   grainType: '小麦',
        //   grainGrade: '一级',
        //   warehouseName: '黑龙江绿野仓',
        //   registerTime: '2023-08-24 10:00:00',
        //   outProgress: '已出仓',
        //   dataStatus: '正常'
        // },
        // {
        //   documentNo: '20230824002',
        //   registrar: '李四',
        //   quantityInOut: '500',
        //   grainType: '小麦',
        //   grainGrade: '一级',
        //   warehouseName: '黑龙江绿野仓',
        //   registerTime: '2023-08-24 11:00:00',
        //   outProgress: '未出仓',
        //   dataStatus: '正常'
        // }
      ]
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.init()
      }
    }
  },
  methods: {
    init() {
      this.dialogTitle = '仓单详情：' + this.receiptNo
      this.loadData()
    },

    async loadData() {
      const res = await getReceiptDetailById({ id: this.receiptId })
      if (res && res.data) {
        // 映射基本信息
        this.warehouseBaseData = this.mapToWarehouseBaseData(res.data)
        // 映射出入库记录
        this.warehouseTableData = this.mapToWarehouseTableData(res.data.orderItems || [])
      } else {
        this.$message.error(res.msg || '获取仓单详情失败')
      }
    },

    // 映射仓单基本信息
    mapToWarehouseBaseData(data) {
      return {
        totalQuantity: data.totalWeight || 0, // 入库总重量
        balanceQuantity: data.balanceWeight || 0, // 余额重量
        pledgedQuantity: data.pledgeWeight || 0, 
        pledgedLoanAmount: data.loanAmount || 0, // 贷款金额
        outQuantity: data.dispatchedWeight || 0, // 已出仓数量
        warehouseCompany: data.companyName || '', // 仓储公司名
        loanBank: data.bankName || '', // 贷款银行
      }
    },

    // 映射出入库记录表格数据
    mapToWarehouseTableData(orderItems) {
      return orderItems.map(item => ({
        documentNo: item.number || '', // 单据号
        registrar: item.driverName || '', // 登记员（司机姓名）
        quantityInOut: item.endNetWeight || 0, // 出入仓数量
        grainType: item.grainCategoryName || '', // 粮食品种
        grainGrade: item.grainCategoryLevel || '', // 粮食等级
        warehouseName: item.storeName || '', // 出入仓库
        registerTime: item.createTime || '', // 登记时间
        outProgress: item.statusName, // 出库进度
        dataStatus: item.dataStatus ==0 ? '正常' : '异常', // 数据状态
      }))
    },

    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less" scoped>
.warehouse-receipt-dialog {
  .el-dialog__header {
    padding: 20px 24px;
    background: #ffffff;
    border-bottom: none;
    .el-dialog__title {
      font-size: 18px;
      font-weight: 600;
      color: #111827;
    }
  }

  .el-dialog__body {
    padding: 24px;
    background: #f9fafb;
  }

  .el-dialog__footer {
    padding: 16px 24px;
    background: #ffffff;
    border-top: 1px solid #e5e7eb;
    text-align: right;
  }
}

.receipt-content {
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;

  .info-section {
    margin-bottom: 40px;

    .info-row {
      display: flex;
      margin-bottom: 16px;

      .info-item {
        flex: 1;
        margin-right: 20px;
        display: flex;
        align-items: center;

        &:last-child {
          margin-right: 0;
        }

        .info-label {
          font-size: 13px;
          font-weight: 500;
          color: #374151;
          margin-right: 3px;
          min-width: 110px;
        }

        .info-input,
        .info-select {
          width: 100%;

          /deep/ .el-input__inner {
            border-radius: 4px;
            padding: 8px 12px;
          }
        }

        .status-tag {
          font-size: 12px;
          padding: 4px 8px;
          margin-top: 8px;
          display: inline-block;
        }
      }
    }
  }

  .voucher-section {
    margin-bottom: 24px;

    .section-title {
      font-size: 14px;
      font-weight: 500;
      color: #111827;
      margin-bottom: 16px;
    }

    .voucher-images {
      display: flex;
      flex-wrap: wrap;

      .voucher-image {
        position: relative;
        width: 200px;
        height: 150px;
        margin-right: 16px;
        margin-bottom: 16px;
        cursor: pointer;
        border-radius: 4px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s;
        }

        .image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.3s;

          .preview-text {
            color: #ffffff;
            font-size: 14px;
          }
        }

        &:hover {
          img {
            transform: scale(1.05);
          }

          .image-overlay {
            opacity: 1;
          }
        }
      }
    }
  }

  .table-section {
    margin-bottom: 24px;

    .section-title {
      font-size: 16px;
      font-weight: 600;
      color: #111827;
      margin-bottom: 16px;
    }

    .out-records-table {
      .el-table__header-wrapper {
        .el-table__header {
          th {
            background-color: #f9fafb;
            font-weight: 500;
            color: #374151;
            border-bottom: 1px solid #e5e7eb;
          }
        }
      }

      .el-table__body-wrapper {
        .el-table__row {
          td {
            border-bottom: 1px solid #f3f4f6;
            color: #111827;
          }

          &:hover {
            background-color: #f9fafb;
          }
        }
      }
    }
  }

  .other-section {
    .info-row {
      .info-item {
        flex: 1;

        .info-input {
          /deep/ .el-textarea__inner {
            min-height: 80px;
            resize: vertical;
          }
        }
      }
    }
  }
}
</style>
